const GroupBy = (array, key) => {
  return array.reduce((result, current) => {
    // Get the value of the key to group by
    const groupValue = current[key];

    // Initialize the group if it doesn't exist
    if (!result[groupValue]) {
      result[groupValue] = [];
    }

    // Add the current object to the appropriate group
    result[groupValue].push(current);

    return result;
  }, {});
};

export default GroupBy;
